import { Input } from 'antd';
import { EkaFocosableElement } from '../../../../common/types/EkaFocusable';

type Props = {
    label: string;
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
    value?: string;
    defaultValue?: string;
    placeholder: string;
    setRef?: (ref: EkaFocosableElement) => void;
};

const FreeText: React.FC<Props> = ({
    setRef,
    label,
    onChange,
    value,
    placeholder,
    onBlur,
    defaultValue,
}) => {
    return (
        <div>
            <div>
                <p className="font-700 text-12 text-neutral-3">{label}</p>
            </div>
            <div>
                <Input.TextArea
                    ref={setRef}
                    autoSize={{ minRows: 2 }}
                    placeholder={placeholder}
                    className="w-full"
                    value={value}
                    defaultValue={defaultValue}
                    onChange={onChange}
                    maxLength={500}
                    onBlur={onBlur}
                />
            </div>
        </div>
    );
};

export default FreeText;
